module.exports = __webpack_public_path__ + "media/images/linkedin-signin-4d1c34c6cc9304f8a7bfe4b7f9dade183677975d2ee79ac743c72a58e20aa4b3.png";